import React, { useEffect, useRef, useState } from 'react'
import AdminCheckBox from '../../../components/CommonComponents/AdminCheckBox';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';
import MessageSubHeading from '../../../components/CommonComponents/MessageSubHeading';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
import { useMyContext } from '../../../components/Provider/CommonProvider';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput';
import { toast } from 'react-toastify';
import AdminGalleryModal from '../../../components/CommonComponents/AdminGalleryModal';
import FileUploader from '../../FileUploader';

const EpisodeSiteStorage = ({ storageSetting, storageLoading, siteTheme }) => {
    const { handleFileChangeProvider, fetchRequest } = useMyContext()

    const location = useLocation()
    const { search } = useLocation();
    const navigate = useNavigate()
    const combinedRef = useRef({})
    const queryParams = new URLSearchParams(search);
    const seriesId = queryParams.get('seriesid');
    const seasonId = queryParams.get('seasonid');
    const episodeId = queryParams.get('episodeid');
    const videoType = [
        { video_type: 'mp4_video_upload', name: 'Episode Upload' },
        { video_type: 'm3u8_url', name: 'M3u8 url' },
        { video_type: 'mp4_url', name: 'Mp4 url' },
        { video_type: 'embed_code', name: 'Embed url' },
    ];

    if (Number(storageSetting?.brightcove_storage) === 1) {
        videoType.push({ video_type: 'brightcove', name: 'Brightcove' });
    }
    const [currentId, setCurrentId] = useState({
        mp4Response: {},
        m3u8URLResponse: {},
        mp4URLResponse: {},
        embedURLResponse: {},
        brightcoveResponse: {},
        moveId: ""
    })
    const [formData, setFormData] = useState({})
    const [formDataError, setFormDataError] = useState({})
    const [loading, setLoading] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [findZone, setFindZone] = useState(false)

    const handleAddMore = (name) => {
        if (name == "m3u8_url") {
            setCurrentId(prev => {
                const clearData = { ...prev }
                clearData.m3u8URLResponse = {}
                return clearData
            })
            setFormData(prev => ({
                ...prev,
                m3u8_url: ""
            }))
        }
        if (name === "mp4_url") {
            setCurrentId(prev => {
                const clearData = { ...prev }
                clearData.mp4URLResponse = {}
                return clearData
            })
            setFormData(prev => ({
                ...prev,
                mp4_url: ""
            }))
        }
        if (name === "embed_code") {
            setCurrentId(prev => {
                const clearData = { ...prev }
                clearData.embedURLResponse = {}
                return clearData
            })
            setFormData(prev => ({
                ...prev,
                embed_code: ""
            }))
        }
        if (name === "brightcove") {
            setCurrentId(prev => {
                const clearData = { ...prev }
                clearData.brightcoveResponse = {}
                return clearData
            })
            setFormData(prev => ({
                ...prev,
                brightcove_video_id: ""
            }))
        }
    }
    const handleNextMethod = (movingId) => {
        navigate(`/edit-episode?episodeid=${movingId}`)
    }
    const baseURL = process.env.REACT_APP_Baseurl
    const libraryApi = `${baseURL}/admin/library/upload`
    const episodeUrlUpload = `${baseURL}/admin/series/episode/url-upload`
    const libraryUploadApi = `${libraryApi}?upload_type=video&clone_to=episode&action_type=${findZone ? "updated" : "created"}&series_id=${seriesId}&season_id=${seasonId}&video_id=${episodeId}`
    const moveApi = `${baseURL}/admin/series/episode/move`
    const assingAPI = `${baseURL}/admin/series/episode/assign`


    const [currentType, setCurrentType] = useState("mp4_video_upload")
    const [galleryModal, setGalleryModal] = useState(false)
    const [selectedIds, setSelectedIds] = useState([]);
    const [galleryModalSourceFillter, setGalleryModalSourceFillter] = useState(1)


    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "radio") {
            if (name === "video_type") {
                setCurrentType(value);
            }
        }
        if (type === 'text') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }))
        }

    }

    const handleToggleGalleryModel = (val) => {
        setGalleryModal(prev => !prev)
        if (val == "clear") {
            setSelectedIds([])
        }
        setGalleryModalSourceFillter(val)
    }

    const handleLibraryChange = async (e, name) => {
        const files = e.target.files;
        const allowedTypes = /video\/(mp4|x-matroska|webm|quicktime|avi)/;
        for (let file of files) {
            if (!allowedTypes.test(file.type)) {
                toast.error(`Unsupported file format: ${file.name}`);
                e.target.value = ''; // Clear the file input
                return;
            }
        }


        if (!files?.length) return;

        const { site_storage_limit, site_storage_memory } = storageSetting;

        // Convert storage limit to bytes
        const memoryUnits = {
            MB: 1024 ** 2,
            GB: 1024 ** 3,
            TB: 1024 ** 4
        };

        const unitMultiplier = memoryUnits[site_storage_memory];
        if (!unitMultiplier) {
            alert(`Invalid storage unit: ${site_storage_memory}`);
            return;
        }

        const byteLimit = site_storage_limit * unitMultiplier;

        // Calculate total file size
        const totalSize = Array.from(files).reduce((sum, file) => sum + file.size, 0);

        if (totalSize > byteLimit) {
            alert(`Upload exceeds limit: ${site_storage_limit} ${site_storage_memory}`);
            e.target.value = null;
            return;
        }
        await handleFileChangeProvider(e, libraryUploadApi, "episode", {});
        e.target.value = null;
    }


    const isValidVideoUrl = (url, extension) => {
        const regex = new RegExp(`^https?:\\/\\/.+\\${extension}$`, "i");
        return regex.test(url);
    };

    const handleUrlUpload = async (name) => {
        const formDataObject = {};
        formDataObject["action_type"] = findZone ? "updated" : "created";
        formDataObject["series_id"] = seriesId;
        formDataObject["season_id"] = seasonId;
        if (findZone) {
            formDataObject["episode_id"] = episodeId;
        }

        let formIsValid = true;

        // MP4 URL Validation
        if (name === "mp4_url") {
            const value = formData?.mp4_url?.trim();
            if (!value) {
                setFormDataError(prev => ({
                    ...prev,
                    mp4_url: "MP4 URL cannot be empty.",
                }));
                combinedRef.current['mp4_url'].focus();
                return;
            }
            if (!isValidVideoUrl(value, ".mp4")) {
                setFormDataError(prev => ({
                    ...prev,
                    mp4_url: "URL must start with http/https and end with .mp4 (e.g., http://domain.com/video.mp4)",
                }));
                combinedRef.current['mp4_url'].focus();
                return;
            }
            formDataObject["mp4_url"] = value;
            formDataObject["video_type"] = name;
        }

        // M3U8 URL Validation
        if (name === "m3u8_url") {
            const value = formData?.m3u8_url?.trim();
            if (!value) {
                setFormDataError(prev => ({
                    ...prev,
                    m3u8_url: "M3U8 URL cannot be empty.",
                }));
                combinedRef.current['m3u8_url'].focus();
                return;
            }
            if (!isValidVideoUrl(value, ".m3u8")) {
                setFormDataError(prev => ({
                    ...prev,
                    m3u8_url: "URL must start with http/https and end with .m3u8 (e.g., http://domain.com/playlist.m3u8)",
                }));
                combinedRef.current['m3u8_url'].focus();
                return;
            }
            formDataObject["m3u8_url"] = value;
            formDataObject["video_type"] = name;
        }

        // Embed Code Validation
        if (name == "embed_code") {
            if (!formData?.embed_code) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    embed_code: "Embed code cannot be empty.",
                }));
                combinedRef.current['embed_code'].focus()
                formIsValid = false;
                return
            } else {
                const embedCode = formData?.embed_code.trim();
                const youtubeEmbedRegex = /^https?:\/\/(?:www\.)?youtube\.com\/embed\/[a-zA-Z0-9_-]+(\?[a-zA-Z0-9_=&-]+)?$/;
                if (!youtubeEmbedRegex.test(embedCode)) {
                    setFormDataError((prevFormData) => ({
                        ...prevFormData,
                        embed_code: "Invalid YouTube embed URL. Please provide a valid URL in format: https://www.youtube.com/embed/VIDEO_ID",
                    }));
                    combinedRef.current['embed_code'].focus()
                    formIsValid = false;
                    return
                }
                else {
                    formDataObject["embed_code"] = embedCode;
                    formDataObject["video_type"] = "embed_code";
                }
            }
        }

        // Brightcove Validation
        if (name === "brightcove") {
            if (!formData?.brightcove_video_id) {
                setFormDataError((prevFormData) => ({
                    ...prevFormData,
                    brightcove_video_id: "Brightcove Video ID cannot be empty.",
                }));
                combinedRef.current['brightcove_video_id'].focus()
                formIsValid = false;
                return
            } else {
                formDataObject["brightcove_video_id"] = formData?.brightcove_video_id.trim();
                formDataObject["video_type"] = "brightcove";
            }
        }

        // If form is valid, make API call
        setLoading(true);
        try {
            const response = await fetchRequest({
                method: 'POST',
                url: `${episodeUrlUpload}`,
                params: {},
                data: formDataObject,
            });

            const result = response;
            if (result?.status) {
                toast.success(result?.message);
                setCurrentId(prev => {
                    const updatedState = { ...prev };
                    if (name === "m3u8_url") {
                        updatedState.m3u8URLResponse = { ...result, id: result?.id };
                    }
                    if (name === "mp4_url") {
                        updatedState.mp4URLResponse = { ...result, id: result?.id };
                    }
                    if (name === "embed_code") {
                        updatedState.embedURLResponse = { ...result, id: result?.id };
                    }
                    if (name === "brightcove") {
                        updatedState.brightcoveResponse = { ...result, id: result?.id };
                    }
                    return updatedState;
                });
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message;
            toast.error(errorMessage || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };




    const handleMoveVideo = async (selectIds) => {
        try {
            const formDataAdd = {};
            formDataAdd["series_id"] = seriesId;
            formDataAdd["season_id"] = seasonId;
            let response, result = null
            if (galleryModalSourceFillter == 1 && !findZone) {
                formDataAdd['video_ids'] = selectIds
                response = await fetchRequest({
                    method: 'POST',
                    url: `${moveApi}`,
                    params: {},
                    data: formDataAdd
                })
                result = response
            }
            else if (galleryModalSourceFillter == 1 || findZone) {
                response = await fetchRequest({
                    method: 'POST',
                    url: `${assingAPI}?video_id=${episodeId}&library_id=${selectIds?.[0]}&updated_type=${findZone ? 'video' : 'trailer'}`,
                    params: {},
                    data: {}
                })
                result = response;
            }
            if (result?.status) {
                if (galleryModalSourceFillter == 1 && !findZone) {
                    navigate(`/manage-episode?seriesid=${seriesId}&seasonid=${seasonId}`)
                }
                else {
                    navigate(`/edit-episode?episodeid=${episodeId}`)

                }
                toast.success(result?.message)
                setSelectedIds([])
                handleToggleGalleryModel()
            }
            else {
                toast.error(result?.message)
            }

        }
        catch (err) {
            setShowOverlay(false);
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
            console.error("error", err)
        }

    }
    const handleCheckboxChange = (id) => {
        if ((galleryModalSourceFillter == 1 && !findZone)) {
            setSelectedIds((prevSelectedIds) => {
                if (prevSelectedIds.includes(id)) {
                    return prevSelectedIds.filter((itemId) => itemId !== id);
                } else {
                    return [...prevSelectedIds, id];
                }
            });
        } else if ((galleryModalSourceFillter == 1 || findZone)) {
            setSelectedIds([id]);
        }
    };


    useEffect(() => {
        setFindZone(episodeId == undefined ? false : true);
    }, [location?.pathname, search]);


    return (
        <>
            {galleryModal && <AdminGalleryModal modelClose={galleryModal} closeAction={handleToggleGalleryModel} sourceType={galleryModalSourceFillter} saveAction={handleMoveVideo} changeAction={handleCheckboxChange} selectedIds={selectedIds} buttonText={(galleryModalSourceFillter == 1 && "Select Video" || galleryModalSourceFillter == 16 && "Select Trailer")} />}
            <div className='theme-bg-color p-4 rounded-3 mb-3 '>
                <div className="radio-options text-center my-2 d-flex flex-wrap  justify-content-start ">
                    {videoType?.map((data, index) => (
                        <div key={index} className={`col-md-3 col-6 mb-2 text-md-center text-start mb-3 `}>
                            <div className="d-flex align-items-center gap-2 ">
                                <AdminCheckBox id="videoTypeOptionRadio" type="radio" className={""} name="video_type" value={data?.video_type} checked={currentType == data?.video_type} onChange={handleInput} />
                                <MessageLabel text={data?.name} className="ms-1 mb-md-0 mb-0 " noMargin />
                            </div>
                        </div>
                    ))}

                </div>
                {(currentType == "mp4_video_upload") ?
                    <>
                        {(storageSetting?.bunnyCdnStorage == 1 && storageSetting?.transcoding_access == 1) ? (
                            /* ── BunnyCDN TUS direct upload ─────────────────────────────── */
                            <FileUploader
                                uploadType="video"
                                cloneTo="episode"
                                actionType={findZone ? "updated" : "created"}
                                videoId={findZone ? episodeId : null}
                                seriesId={seriesId}
                                seasonId={seasonId}
                                nextHref={!findZone ? (vid) => `/edit-episode?episodeid=${vid}` : null}
                            />
                        ) : (
                            /* ── Regular server-side chunked upload ─────────────────────── */
                            <div className="customDropWrapper rounded-4 theme-bg-color-secondary">
                                <div className="dropZoneText d-flex flex-column align-items-center justify-content-center">
                                    <MessageSubHeading text="Drag and drop video files here, or click to select files" className="theme-text-color" noMargin />
                                    <MessageSubHeading className={"text-center"} text={`Max Upload Limit (${storageSetting?.site_storage_limit} ${storageSetting?.site_storage_memory})`} noMargin />
                                </div>
                                <input id="videoUploadFile" type="file" accept="video/mp4, video/x-matroska, video/x-m4v, video/webm, video/quicktime, video/x-msvideo" className="w-100 h-100" multiple onChange={(e) => { handleLibraryChange(e, "video") }} />
                            </div>
                        )}
                        <AdminCustomButton saveMethod={() => handleToggleGalleryModel(1)} saveText="Choose from library" className="mt-3" />
                    </> : ""}

                {currentType == "mp4_url" && (
                    <>
                        <MessageLabel text="Mp4 URL" />
                        <AdminCustomInput id="episode-mp4-url" type="text" name="mp4_url" value={formData?.mp4_url} onChange={handleInput} placeHolder={"Paste the mp4 url"} ref={(el) => (combinedRef.current.mp4_url = el)} error={formDataError?.mp4_url} />
                        {!currentId?.mp4URLResponse?.id && <AdminCustomButton id="episode-mp4-url-button" saveMethod={() => handleUrlUpload('mp4_url')} saveText="Submit" className="d-block mt-3  ms-auto" loading={loading} />}
                        {currentId?.mp4URLResponse?.id &&
                            <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
                                <AdminCustomButton id="episode-mp4-url-add" saveMethod={() => handleAddMore('mp4_url')} saveText="Add More" className="d-inline-block" />
                                <AdminCustomButton id="episode-mp4-url-next" saveMethod={() => handleNextMethod(currentId?.mp4URLResponse?.id)} saveText="Proceed Next" className="d-inline-block" />
                            </div>}
                    </>
                )}
                {currentType == "m3u8_url" && (
                    <>
                        <MessageLabel text="M3u8 Url" />
                        <AdminCustomInput id="episode-m3u8-url" type="text" name="m3u8_url" value={formData?.m3u8_url} onChange={handleInput} placeHolder={"Paste the m3u8 url"} ref={(el) => (combinedRef.current.m3u8_url = el)} error={formDataError?.m3u8_url} />
                        {!currentId?.m3u8URLResponse?.id && <AdminCustomButton saveMethod={() => handleUrlUpload('m3u8_url')} saveText="Submit" className="d-block mt-3  ms-auto" loading={loading} />}
                        {currentId?.m3u8URLResponse?.id &&
                            <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
                                <AdminCustomButton id="episode-m3u8-url-add" saveMethod={() => handleAddMore('m3u8_url')} saveText="Add More" className="d-inline-block" />
                                <AdminCustomButton id="episode-m3u8-url-next" saveMethod={() => handleNextMethod(currentId?.m3u8URLResponse?.id)} saveText="Proceed Next" className="d-inline-block" />
                            </div>}

                    </>)
                }
                {currentType == "embed_code" && (
                    <>
                        <MessageLabel text="Embed code:" />
                        <p className='mb-3'>( https://www.youtube.com/embed/xxxxx )</p>
                        <AdminCustomInput id="episode-embed-code" type="text" name="embed_code" value={formData?.embed_code} onChange={handleInput} placeHolder={"Paste the embed code url"} ref={(el) => (combinedRef.current.embed_code = el)} error={formDataError?.embed_code} />
                        {!currentId?.embedURLResponse?.id && <AdminCustomButton id="episode-embed-code-button" saveMethod={() => handleUrlUpload('embed_code')} saveText="Submit" className="d-block mt-3  ms-auto" loading={loading} />}
                        {currentId?.embedURLResponse?.id &&
                            <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
                                <AdminCustomButton id="episode-embed-code-add" saveMethod={() => handleAddMore('embed_code')} saveText="Add More" className="d-inline-block" />
                                <AdminCustomButton id="episode-embed-code-next" saveMethod={() => handleNextMethod(currentId?.embedURLResponse?.id)} saveText="Proceed Next" className="d-inline-block" />
                            </div>}
                    </>
                )}
                {currentType == "brightcove" && (
                    <>
                        <MessageLabel text="Brightcove Video ID" />
                        <AdminCustomInput id="episode-brightcove-id" type="text" name="brightcove_video_id" value={formData?.brightcove_video_id} onChange={handleInput} placeHolder={"Enter Brightcove Video ID"} ref={(el) => (combinedRef.current.brightcove_video_id = el)} error={formDataError?.brightcove_video_id} />
                        {!currentId?.brightcoveResponse?.id && <AdminCustomButton id="episode-brightcove-button" saveMethod={() => handleUrlUpload('brightcove')} saveText="Submit" className="d-block mt-3  ms-auto" loading={loading} />}
                        {currentId?.brightcoveResponse?.id &&
                            <div className="mt-3 d-flex gap-2 ms-auto justify-content-end">
                                <AdminCustomButton id="episode-brightcove-add" saveMethod={() => handleAddMore('brightcove')} saveText="Add More" className="d-inline-block" />
                                <AdminCustomButton id="episode-brightcove-next" saveMethod={() => handleNextMethod(currentId?.brightcoveResponse?.id)} saveText="Proceed Next" className="d-inline-block" />
                            </div>}
                    </>
                )}
            </div>
        </>
    )
}
const mapStateToProps = (state) => ({
    storageSetting: state.storageSetting.data,
    storageLoading: state.storageSetting.loading,
    siteTheme: state.siteTheme.siteTheme
});

export default connect(mapStateToProps)(EpisodeSiteStorage)
